(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/extends", "@babel/runtime/helpers/objectWithoutProperties", "react", "@blueprintjs/core", "prop-types", "classnames", "./MainMenuItem"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/extends"), require("@babel/runtime/helpers/objectWithoutProperties"), require("react"), require("@blueprintjs/core"), require("prop-types"), require("classnames"), require("./MainMenuItem"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a._extends, a.objectWithoutProperties, a.react, a.core, a.propTypes, a.classnames, a.MainMenuItem), a.MainMenu = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g, h) {
  "use strict";

  var i = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.MainMenu = void 0, b = i(b), c = i(c), d = i(d), f = i(f), g = i(g), h = i(h);

  var j = function j(a) {
    var f = a.className,
        i = a.navHeader,
        j = a.navItems,
        k = (0, c.default)(a, ["className", "navHeader", "navItems"]);
    return j.length || i ? d.default.createElement(e.Navbar, (0, b.default)({
      className: (0, g.default)(["navBar", e.Classes.DARK, f])
    }, k), i && d.default.createElement(e.NavbarHeading, {
      className: "navBar__header"
    }, d.default.createElement(h.default, i)), 0 < j.length && j.map(function (a, b) {
      return (// eslint-disable-next-line react/no-array-index-key
        d.default.createElement(e.NavbarGroup, {
          key: b,
          className: "navBar__group"
        }, d.default.createElement("ul", null, a.map(function (a) {
          return d.default.createElement("li", {
            key: a.id
          }, d.default.createElement(h.default, a));
        })))
      );
    })) : null;
  };

  a.MainMenu = j, j.propTypes = {
    className: f.default.string,
    navHeader: f.default.shape({
      component: f.default.func,
      href: f.default.string,
      icon: f.default.oneOfType([f.default.string, f.default.shape({})]),
      id: f.default.string,
      label: f.default.string
    }),
    navItems: f.default.arrayOf(f.default.arrayOf(f.default.shape({
      component: f.default.func,
      href: f.default.string,
      icon: f.default.oneOfType([f.default.string, f.default.shape({})]),
      id: f.default.string,
      label: f.default.string
    })))
  }, j.defaultProps = {
    className: "",
    navHeader: void 0,
    navItems: []
  };
  a.default = j;
});